import { Hero } from "@/components/lumi/Hero";
import { Marquee } from "@/components/lumi/Marquee";
import { Collection } from "@/components/lumi/Collection";
import { ShadeStudio } from "@/components/lumi/ShadeStudio";
import { Bento } from "@/components/lumi/Bento";
import { Ritual } from "@/components/lumi/Ritual";
import { Signup } from "@/components/lumi/Signup";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Collection />
      <ShadeStudio />
      <Bento />
      <Ritual />
      <Signup />
    </main>
  );
}
